import styled from 'styled-components';
import { Form } from 'formik';

// CONSTANTS
import { SANTAS_GRAY } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const SRegistrationForm = styled(Form)`
  display: flex;
  flex-direction: column;

  button[type='submit'] {
    margin-top: 40px;
  }

  &.form--dialog {
    button[type='submit'] {
      align-self: center;
      margin-top: 20px;
    }
  }

  ${breakpoints.up('md')} {
    max-width: 445px;

    button[type='submit'] {
      max-width: 200px;
    }
  }
`;

export const TermsContainer = styled.label`
  display: flex;
  justify-content: flex-start;
  color: ${SANTAS_GRAY};

  .MuiCheckbox-root {
    align-items: flex-start;
    display: block;
    width: 18px;
    height: 18px;
    margin-right: 9px;

    .icon-correct-symbol:before {
      width: 18px;
      height: 18px;
    }
  }
`;

export default SRegistrationForm;
